// extracted by mini-css-extract-plugin
export default {"rating":"VB-z","numberOfStars":"WB-z","count":"XB-z","barGraphSpacing":"YB-z","barGraph":"ZB-z"};